import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantInformationService {

  private readonly tenant = new BehaviorSubject<string>('fhco');
  public $tenant = this.tenant.asObservable();

  /**
   * Evaluates the tenant based on the current URL.
   */
  public getTenantName(): string {
    return this.tenant.getValue();
  }

  setTenant(tenant: string) {
    this.tenant.next(tenant);
  }
}
